import { components } from 'react-select';
import { observer } from 'mobx-react';
import React from 'react';

const BaasicDropdownOptionOverride = ({ shouldDisplayCallback, Component, ...otherProps }) => {
	const { Option } = components;
	const { data } = otherProps;
	const displayOverrideOption = shouldDisplayCallback ? shouldDisplayCallback(data) : true;
	return (
		<Option {...otherProps}>
			{data.label}
			{displayOverrideOption && <Component {...otherProps} />}
		</Option>
	);
};

export default observer(BaasicDropdownOptionOverride);



// WEBPACK FOOTER //
// ./src/core/components/select/BaasicDropdownOptionOverride.jsx